import React, { createContext, useState, useContext, useEffect } from 'react';
import i18n, { loadLanguageAsync } from '../i18n/i18n';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(
    localStorage.getItem('language') || 'uk'
  );

  const changeLanguage = async (newLang) => {
    try {
      localStorage.setItem('language', newLang);
      setCurrentLanguage(newLang);
      await loadLanguageAsync(newLang);
      await i18n.changeLanguage(newLang);
    } catch (error) {
      console.error('LanguageContext: Error changing language:', error);
    }
  };

  useEffect(() => {
    const language = localStorage.getItem('language') || 'uk';
    setCurrentLanguage(language);
    loadLanguageAsync(language).then(() => {
      i18n.changeLanguage(language);
    });
  }, []);

  return (
    <LanguageContext.Provider value={{ 
      currentLanguage, 
      changeLanguage
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
